export const xsmMobile = '(max-width: 345px)';
export const smMobile = '(max-width: 380px)';
export const mobile = '(max-width: 480px)';
export const xsmTablet = '(max-width: 640px)';
export const smTablet = '(max-width: 767px)';
export const tablet = '(max-width: 875px)';
export const xsmDesktop = '(max-width: 1000px)';
export const smDesktop = '(max-width: 1200px)';
